<template>
    <div class="modal-container-cont">
        <div class="modal-container" :class="{ 'faceDetection': faceDetection }">
            <!-- <div class="modal-form-container">
                <div class="title-box">
                    <h2>{{ getString('login_consumidor') }}</h2>
                </div>
            </div> -->
            <!-- <input class="hidden-input" type="text" autocomplete="off" id="barcodeinput" v-model="barCodeInput"> -->
            <!-- <div v-if="!faceDetection && !loggedSuccessfully" class="form"
                :class="{ 'lockKeyboardCons': lockKeyboardCons }">
                <div class="config-item" :class="{ 'distance-bottom': !lockKeyboardCons }">
                    <div class="label-container"
                        :class="{ 'disabled-label': loggedSuccessfully || changeConsumerFor !== '' }">
                        <label for="consumer" v-text="getString('consumidor')"></label>
                    </div>
                    <div id="consumer" ref="consumerDiv" class="div-input-android"
                        :class="{ 'active-input': isTheActiveInput('consumerDiv'), 'disabled-input': loggedSuccessfully }"
                        @click="switchActiveInput('consumerDiv')">
                    </div>
                </div>

                <div class="config-item" v-if="!lockKeyboardCons">
                    <div class="label-container" :class="{ 'disabled-label': loggedSuccessfully }">
                        <label for="password" v-text="getString('senha')"></label>
                    </div>
                    <div id="password" ref="passwordDiv" class="div-input-android"
                        :class="{ 'active-input': isTheActiveInput('passwordDiv'), 'disabled-input': loggedSuccessfully }"
                        @click="switchActiveInput('passwordDiv')">
                    </div>
                </div>
            </div>
            <div v-else-if="!loggedSuccessfully && !isCameraAndroid()" class="ai-face-detection-container">
                <faceVideoComp :portrait="true" v-if="!pauseDetection && !imageBase64"></faceVideoComp>
                <img :src="imageBase64" v-if="imageBase64" />
            </div>

            <div class="barcode-info" v-if="lockKeyboardCons && !loggedSuccessfully && !faceDetection">
                <img :src="imgBarCode" />
                <p v-text="getString('bar_code_cracha')"></p>
            </div> -->
            <ConsumerLogin class="form" :preSelectedMethod="loginMethod" v-if="!loggedSuccessfully"
                @loginSuccess="loginSuccess()" @cancelLogin="cancelLogin($event)"
                @disableOverlayClick="$emit('disableOverlayClick')" @enableOverlayClick="$emit('enableOverlayClick')"
                @changeMethod="changeMethod()" />

<!--             <div class="change-method-button" v-if="!!faceDetection && !loggedSuccessfully">
                <DefaultButton :text="getNameMethod()" :outlined="true" @defaultBtnClick="changeMethod()">
                </DefaultButton>
            </div>
            <DefaultButton class="new-login-button" :text="getString('Reconhecimento Facial')"
                v-if="controlsEnabled && !loggedSuccessfully && useFaceRecognition && !faceDetection"
                @defaultBtnClick="startFaceRecognition()">
            </DefaultButton>
            <DefaultButton class="new-login-button" :text="getString('cadastrar_nova_senha')"
                v-if="controlsEnabled && !loggedSuccessfully && !lockKeyboardCons && !faceDetection"
                @defaultBtnClick="openNewPasswordModal()">
            </DefaultButton> -->

            <div v-if="loggedSuccessfully && !hasProductUnavailable">
                <div class="balance-information">
                    <h2>{{ getString('login_sucesso') }}</h2>
                    <div class="balance-container">
                        <div :class="['balance-row', { 'total-div': isPersonalCredit() }]">
                            <span class="balance-text">{{ getString('total_da_compra') }}</span>
                            <span class="balance-value" v-text="cartTotalText"></span>
                        </div>

                        <!-- Saldos por família no Crédito Pessoal -->
                        <template v-if="isPersonalCredit()">
                            <div v-for="(family, key) in treatedFamilyBalances" :key="key"
                                class="balance-inner-information">
                                <div class="balance-row upper-div">
                                    <span class="balance-text">{{ getString('saldo_familia') + ` ${family.familyName}:` }}</span>
                                    <span class="balance-value" v-text="family.familyBalance"></span>
                                </div>

                                <div class="balance-row upper-div">
                                    <span class="balance-text">{{ getString('total_familia') + ` ${family.familyName}:` }}</span>
                                    <span class="balance-value" v-text="family.familyTotalCart"></span>
                                </div>

                                <div class="balance-row">
                                    <span class="balance-text">{{ (family.complementValue ? getString('valor_complemento') : getString('saldo_apos_pagamento')) + ` (${family.familyName}):` }}</span>
                                    <span class="balance-value">{{ family.complementValue || family.familyNextBalance }}</span>
                                </div>
                            </div>
                        </template>

                        <!-- Saldo geral no Débito Consumidor -->
                        <template v-else-if="isConsumerDebit() && configExibeSaldoConsumidorSemControle()">
                            <div class="balance-inner-information">
                                <div class="balance-row upper-div margin-top">
                                    <span class="balance-text">{{ getString('saldo_cliente') }}</span>
                                    <span class="balance-value" v-text="consumerDebitBalance"></span>
                                </div>

                                <div class="balance-row upper-div" v-if="consumerDebitComplementValue">
                                    <span class="balance-text">{{ getString('valor_complemento') }}</span>
                                    <span class="balance-value">{{ consumerDebitComplementValue }}</span>
                                </div>

                                <div class="balance-row">
                                    <span class="balance-text">{{ getString('saldo_apos_pagamento') }}</span>
                                    <span class="balance-value">{{ consumerDebitAfterPaymentBalance }}</span>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>

                <div v-if="isPersonalCredit()">
                    <div class="recharge-button" visible v-if="rechargeIsEnabled">
                        <DefaultButton :text="getString('recarregar_saldo')"
                            @defaultBtnClick="openRechargeModal()"></DefaultButton>
                    </div>
                    <div class="recharge-button" v-else>
                        <span class="recharge-unavailable" v-text="getString('recarregar_saldo_indisponivel')"></span>
                    </div>
                </div>
            </div>

            <div v-if="loggedSuccessfully && hasProductUnavailable">
                <div class="products-title">
                    {{ getString('produtos_excedidos') }}
                    <span v-if="!isModotap()"> {{ getString('alterar_produtos') }} </span>
                    <span v-else class="alert"> {{ getString('redirecione_caixa') }}</span>
                </div>
                <div class="products-container">
                    <div v-for="(product, key) in getUnavaiableProducts()" :key="product.idx">
                        <ul class="products" :class="{ 'tap-mode': isModotap() }">
                            <li :class="{ 'tap-mode': isModotap() }" class="name-container">
                                <span class="name-product">
                                    {{ getProductLanguage(product, 'productName') }}
                                    <span :class="{ 'unavaiable': getLimits(product.productCode) }"
                                        v-if="productsUnavailable[product.productCode]"
                                        v-text="buildText(product.productCode)"></span>
                                </span>
                                <ul v-if="product.observations && product.observations.length > 0">
                                    <li v-for="(obs, key2) in getUnavaiableObs(product.observations)" :key="key2"
                                        class="product-obs">
                                        <span v-text="getProductLanguage(obs, 'obsName')"></span>
                                        <span :class="{ 'unavaiable': getLimits(obs.obsProductCode) }"
                                            v-if="productsUnavailable[obs.obsProductCode]"
                                            v-text="buildText(obs.obsProductCode)"></span>
                                    </li>
                                </ul>
                                <template v-if="product && product.productCombo && product.productCombo.length > 0">
                                    <ul class="combo-items"
                                        v-for="(productC, key3) in getUnavaiableCombo(product.productCombo)"
                                        :key="key3">
                                        <li>
                                            <div class="combo-item">
                                                <span v-text="getProductLanguage(productC, 'subItemName')"></span>
                                                <span :class="{ 'unavaiable': getLimits(productC.subItemCode) }"
                                                    v-if="productsUnavailable[productC.subItemCode]"
                                                    v-text="buildText(productC.subItemCode)"></span>
                                            </div>
                                            <ul v-if="productC.observations && productC.observations.length > 0">
                                                <li v-for="(obsC, key4) in getUnavaiableObs(productC.observations)"
                                                    :key="key4" class="combo-obs">
                                                    <span v-text="getProductLanguage(obsC, 'subItemObsName')"></span>
                                                    <span
                                                        :class="{ 'unavaiable': getLimits(obsC.subItemObsProductCode) }"
                                                        v-if="productsUnavailable[obsC.subItemObsProductCode]"
                                                        v-text="buildText(obsC.subItemObsProductCode)"></span>
                                                </li>
                                            </ul>
                                            <template v-if="productC.choosen">
                                                <ul v-for="(choosen, key5) in getProductsComboCombo(productC.choosen)"
                                                    :key="key5">
                                                    <li class="c-combo-items">
                                                        <span
                                                            v-text="getProductLanguage(choosen, 'subItemName')"></span>
                                                        <span :class="{ 'unavaiable': getLimits(choosen.subItemCode) }"
                                                            v-if="productsUnavailable[choosen.subItemCode]"
                                                            v-text="buildText(choosen.subItemCode)"></span>
                                                    </li>
                                                    <ul v-if="choosen.observations && choosen.observations.length > 0">
                                                        <li v-for="(obsCC, key6) in getUnavaiableObs(choosen.observations)"
                                                            :key="key6">
                                                            <span
                                                                v-text="getProductLanguage(obsCC, 'subItemObsName')"></span>
                                                            <span
                                                                :class="{ 'unavaiable': getLimits(obsCC.subItemObsProductCode) }"
                                                                v-if="productsUnavailable[obsCC.subItemObsProductCode]"
                                                                v-text="buildText(obsCC.subItemObsProductCode)"></span>
                                                        </li>
                                                    </ul>
                                                </ul>
                                            </template>
                                        </li>
                                    </ul>
                                </template>
                            </li>
                            <div class="price-container" v-if="!isModotap() && !product.isABox">
                                <span class="price" v-text="getProductPrice(product)"></span>
                                <div class="circle_buttons">
                                    <CircleButton class="edit_button"
                                        :disabled="product.insertedByEan13 || product.isertedByBarCode"
                                        :big="iconesGrandes" :icon="edit_white"
                                        @circleBtnClick="editProduct(product, key)">
                                    </CircleButton>
                                    <CircleButton :icon="delete_white" :big="iconesGrandes"
                                        @circleBtnClick="deleteProduct(product.idx)"></CircleButton>
                                </div>
                                <QuantityControl :quantity="product.quantity"
                                    @circleBtnRemove="decreaseQtty(product.idx)"
                                    @circleBtnAdd="increaseQtty(product.idx)"></QuantityControl>
                            </div>
                        </ul>
                    </div>
                </div>
            </div>

<!--             <AndroidKeyboard id="android-keyboard"
                v-if="!loggedSuccessfully && !lockKeyboardCons && !this.faceDetection" :inputElement="inputElement"
                :layout="layout" :isPasswordField="isPasswordField" @passwordCharacterTyped="passwordCharacterTyped"
                @passwordCharacterErased="passwordCharacterErased" @passwordFieldCleaned="passwordFieldCleaned">
            </AndroidKeyboard> -->

            <div class="prod-item-footer" :class="{ 'faceDetection': faceDetection }" v-if="loggedSuccessfully">
                <!-- <DefaultButton v-if="showCancelButton" :text="getString('cancelar')" :disabled="!controlsEnabled"
                    outlined="true" @defaultBtnClick="cancel()"></DefaultButton> -->
                <!--  <DefaultButton v-if="controlsEnabled && !loggedSuccessfully && !faceDetection"
                    :text="getString('confirmar')" @defaultBtnClick="modalConfirm()"></DefaultButton>
                <DefaultButton v-else-if="!controlsEnabled && !loggedSuccessfully && !faceDetection"
                    :text="getString('aguarde')" disabled="true" @defaultBtnClick="modalConfirm()"></DefaultButton>
            -->
                <DefaultButton v-if="!hasQuantityExceeded && hasProductUnavailable" :text="getString('confirmar')"
                    @defaultBtnClick="overrideCart()"></DefaultButton>
                <DefaultButton v-else-if="hasQuantityExceeded && hasProductUnavailable" :outlined="true"
                    :text="isModotap() ? getString('voltar_inicio') : getString('voltar_cardapio')"
                    @defaultBtnClick="backToMenu()">
                </DefaultButton>
                <DefaultButton v-else-if="!isStandardLogin() && !hasQuantityExceeded && loggedSuccessfully"
                    :text="getString('confirmar_pagamento')" @defaultBtnClick="confirmPayment()"></DefaultButton>
                <DefaultButton v-else
                    :text="loggedSuccessfully ? getString('continuar') : getString('fechar')"
                    @defaultBtnClick="closeModal()">
                </DefaultButton>
            </div>
        </div>

        <div class="inner-overlay" v-if="showRechargeModal" @click="closeRechargeModal()"></div>
        <RechargeModal v-if="showRechargeModal" :productFamilies="productFamilies"
            @newBalanceReceived="newBalanceReceived" @closeRechargeModal="closeRechargeModal"
            @disableOverlayClick="overlayClickEnabled = false" @enableOverlayClick="overlayClickEnabled = true">
        </RechargeModal>
    </div>
</template>

<script>

import Util from '@/assets/libs/util'
import eventModule from '@/assets/libs/eventModule'
import DefaultButton from '@/components/DefaultButton'
import CartController from '@/assets/controllers/CartController'
import PaymentController from '@/assets/controllers/PaymentController'
import IdentifiedConsumerController from '@/assets/controllers/IdentifiedConsumerController'
import ProductController from '@/assets/controllers/ProductController'
import DifferentiatedPricesController from '@/assets/controllers/DifferentiatedPricesController'
import requestModule from '@/assets/libs/requestModule'
import RechargeModal from '@/components/RechargeModal'
import LocaleController from '@/assets/controllers/LocaleController'
import QuantityControl from '@/components/QuantityControl'
import CircleButton from '@/components/CircleButton'
import ConsumerLogin from '@/components/consumerLogin/ConsumerLogin'

export default {
    name: 'PersonalCreditModal',
    components: {
        DefaultButton,
        RechargeModal,
        QuantityControl,
        CircleButton,
        ConsumerLogin
    },
    data () {
        return {
            showCancelButton: true,
            controlsEnabled: true,
            loggedSuccessfully: false,
            treatedFamilyBalances: [],
            consumerDebitBalance: '',
            consumerDebitComplementValue: null,
            consumerDebitAfterPaymentBalance: '',
            cartTotalText: '',
            clientCode: null,
            consumerCode: null,
            consumerName: null,
            showRechargeModal: false,
            overlayClickEnabled: true,
            productFamilies: [],
            lockKeyboardCons: Util.isLockKeyboardCons(),
            hasProductUnavailable: false,
            cart: [],
            productsUnavailable: {},
            hasQuantityExceeded: false,
            edit_white: require('../../static/icons/edit_white.svg'),
            delete_white: require('../../static/icons/delete_white.svg'),
            iconesGrandes: Util.getLocalConfigs('iconesGrandes'),
            faceDetection: false,
            rechargeIsEnabled: false,
            loginMethod: 'password',
            useFaceRecognition: Util.getLocalConfigs('useFaceRecognition'),
            exibeSaldoConsumidorSemControle: Util.getLocalConfigs('exibeSaldoConsumidorSemControle'),
            controlaSaldo: false
        }
    },
    props: [
        'method',
        'changeConsumerFor'
    ],
    created () {
        eventModule.$on('updateHasQuantityExceeded', this.updateHasQuantityExceeded)
        if (this.useFaceRecognition) {
            this.loginMethod = 'faceRecognition'
            this.faceDetection = true
        } else if (this.lockKeyboardCons) {
            this.loginMethod = 'badgeNumber'
            this.faceDetection = false
        } else {
            this.loginMethod = 'password'
            this.faceDetection = false
        }
    },
    beforeDestroy () {
        eventModule.$off('updateHasQuantityExceeded')
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        resetModalConsumerState: function () {
            this.loggedSuccessfully = false
            this.consumerName = null
            this.clientCode = null
            this.consumerCode = null
            this.cart = []
            this.productsUnavailable = {}
            this.hasProductUnavailable = false
            this.hasQuantityExceeded = false
            this.treatedFamilyBalances = []
            this.consumerDebitBalance = ''
            this.consumerDebitAfterPaymentBalance = ''
            this.cartTotalText = ''
            this.rechargeIsEnabled = false
            this.consumerDebitComplementValue = null
            this.productFamilies = []
            this.showCancelButton = true
            IdentifiedConsumerController.userLogout()
            IdentifiedConsumerController.clearConsumerData()
        },
        isStandardLogin: function () {
            return this.method == null
        },
        openRechargeModal: function () {
            PaymentController.startRechargeMode()
            this.showRechargeModal = true
        },
        closeRechargeModal: function () {
            if (this.overlayClickEnabled) {
                this.showRechargeModal = false
                PaymentController.stopRechargeMode()
            }
        },
        newBalanceReceived: function (rechargeData) {
            IdentifiedConsumerController.updateFamilyBalances(rechargeData)
            let cart = CartController.getCart()
            this.treatedFamilyBalances = IdentifiedConsumerController.treatFamilyBalances(cart)
        },
        isPersonalCredit: function () {
            return this.method && this.method.IDTIPORECE === '9'
        },
        isConsumerDebit: function () {
            return this.method && this.method.IDTIPORECE === 'A'
        },
        closeModal: function () {
            if (this.loggedSuccessfully) {
                this.$emit('closeModal')
            } else {
                this.cancel()
            }
        },
        cancel: async function () {
            do {
                await new Promise(resolve => setTimeout(resolve, 100))
            } while (!this.controlsEnabled)
            this.resetModalConsumerState()
            this.$emit('closeModal')
        },
        loginSuccess: async function () {
            this.controlsEnabled = false
            this.$emit('disableOverlayClick')
            try {
                await this.applyPostConsumerLoginSuccess()
                this.faceDetection = false
            } catch (error) {
                console.log('Erro ao finalizar login do consumidor', error)
            } finally {
                this.controlsEnabled = true
                this.$emit('enableOverlayClick')
            }
        },
        applyPostConsumerLoginSuccess: async function () {
            let consumerData = IdentifiedConsumerController.getConsumerData()
            if (!consumerData || !consumerData.logged) {
                console.warn('applyPostConsumerLoginSuccess: consumidor não identificado no controller')
                return
            }

            let familyBalances = []
            try {
                familyBalances = (consumerData.personalCredit && consumerData.personalCredit.familyBalances)
                    ? consumerData.personalCredit.familyBalances
                    : []
                this.productFamilies = this.getProductFamilies(familyBalances)
                this.rechargeIsEnabled = false
                for (let family of familyBalances) {
                    if (family.allowTopUp && family.allowTopUp !== 'N') {
                        this.rechargeIsEnabled = true
                        break
                    }
                }
            } catch (error) {
                this.productFamilies = []
                this.rechargeIsEnabled = false
                console.log('Nao foi possivel recuperar o saldo do consumidor')
                console.log(error)
            }

            try {
                this.hasQuantityExceeded = false
                this.clientCode = consumerData.clientCode
                this.consumerCode = consumerData.consumerCode
                this.consumerName = consumerData.consumerName
            } catch (error) {
                console.log('Nao foi possivel recuperar os dados do consumidor')
                console.log(error)
            }

            this.hasProductUnavailable = await IdentifiedConsumerController.getProductsLimits(this.method)
            this.updateHasQuantityExceeded()
            if (this.hasProductUnavailable && this.hasQuantityExceeded) {
                this.cart = CartController.getCart()
                this.cart.forEach((e, key) => {
                    e.idx = key
                })
                this.productsUnavailable = CartController.getUnavailableProducts()
                this.showCancelButton = true
            }

            if (Util.isTapMode()) {
                await this.editConsumerAndUpdateTapPrices()
            } else {
                await this.updateTaaPrices()
            }
        },
        cancelLogin: function (error = false) {
            this.loggedSuccessfully = false
            if (error && this.faceDetection) {
                this.faceDetection = false
                this.changeMethod('faceRecognition')
            } else {
                this.cancel()
            }
        },
        getProductFamilies: function (familyBalances) {
            let productFamilies = []

            familyBalances.forEach(family => {
                if (family.allowTopUp && family.allowTopUp !== 'N') {
                    productFamilies.push({
                        familyName: family.familyName,
                        familyCode: family.familyCode
                    })
                }
            })

            return productFamilies
        },
        editConsumerAndUpdateTapPrices: async function () {
            let consumerData = IdentifiedConsumerController.getConsumerData()

            let changeConsumerReqObj = {
                subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
                saleCode: consumerData.saleCode,
                clientCode: consumerData.clientCode,
                consumerCode: consumerData.consumerCode
            }

            let changeConsumerResponse = await requestModule.postRequest('sale/editConsumer', changeConsumerReqObj).then(res => res || {}).catch((e) => { })

            if (changeConsumerResponse && !changeConsumerResponse.error) {
                let comandaNumber = consumerData.comandaNumber
                let error = await ProductController.getProductsFromComanda(comandaNumber)

                if (!error.error) {
                    this.showBalancesToClient()
                    this.setLoggedSuccessfully()
                }
            } else {
                let message = changeConsumerResponse != null && changeConsumerResponse.message != null ? changeConsumerResponse.message : this.getString('erro_editar_consumidor_do_pedido')
                Util.showInfoModal(message)
            }
        },
        showBalancesToClient: function () {
            this.cartTotalText = CartController.calculateTotalPrice()
            let cart = CartController.getCart()
            let consumerData = IdentifiedConsumerController.getConsumerData()
            let blockLowBalance = ((consumerData) && (consumerData.consumerDebit) && (consumerData.consumerDebit.blockLowBalance))

            if (this.isPersonalCredit()) {
                this.treatedFamilyBalances = IdentifiedConsumerController.treatFamilyBalances(cart)
                    .map(family => {
                        // Se blockLowBalance for nulo, permite saldo negativo sem limite
                        if (blockLowBalance == null) {
                            return {
                                ...family,
                                complementValue: null
                            }
                        }

                        let balanceLimit = family.negativeBalance === 'S' ? blockLowBalance : 0
                        return {
                            ...family,
                            complementValue: family.familyNextBalanceRaw < balanceLimit
                                ? Util.formatMoney(balanceLimit - family.familyNextBalanceRaw)
                                : null
                        }
                    })
            } else if (this.isConsumerDebit()) {
                let balance = IdentifiedConsumerController.getConsumerDebitBalance()
                let cartTotal = CartController.getTotalPriceAsFloat()
                let afterPayment = (balance || 0) - cartTotal

                this.consumerDebitBalance = Util.formatMoney(balance || 0)

                // Se blockLowBalance for nulo, permite saldo negativo sem restrições
                if (blockLowBalance == null) {
                    this.consumerDebitAfterPaymentBalance = Util.formatMoney(afterPayment)
                    this.consumerDebitComplementValue = null
                    this.controlaSaldo = false
                } else {
                    this.controlaSaldo = true
                    this.consumerDebitAfterPaymentBalance = Util.formatMoney(
                        afterPayment < blockLowBalance ? blockLowBalance : afterPayment
                    )

                    if ((afterPayment < blockLowBalance) && (balance >= blockLowBalance)) {
                        this.consumerDebitComplementValue = Util.formatMoney(blockLowBalance - afterPayment)
                    } else if (balance < blockLowBalance) {
                        this.consumerDebitAfterPaymentBalance = Util.formatMoney(balance)
                        this.consumerDebitComplementValue = Util.formatMoney(cartTotal)
                    } else {
                        this.consumerDebitComplementValue = null
                    }
                }
            }
        },
        setLoggedSuccessfully: function () {
            if (!this.hasQuantityExceeded) this.showCancelButton = false
            this.loggedSuccessfully = true
        },
        updateTaaPrices: async function () {
            let consumerData = IdentifiedConsumerController.getConsumerData()
            await DifferentiatedPricesController.fetchDiffPrices(consumerData.clientCode, consumerData.consumerCode)
            await CartController.applyDifferentiatedPrices()
            this.showBalancesToClient()
            this.setLoggedSuccessfully()
        },
        confirmPayment: function () {
            if (this.controlsEnabled) {
                if (this.allowedPaymentForUser()) {
                    this.$emit('personalCreditPayment', this.method)
                } else {
                    this.showNotAllowedMethodAlert()
                }
            }
        },
        allowedPaymentForUser: function () {
            let isPersonalCredit = this.method && this.method.IDTIPORECE === '9'
            let isConsumerDebit = this.method && this.method.IDTIPORECE === 'A'
            let consumerData = IdentifiedConsumerController.getConsumerData()

            if (isPersonalCredit) {
                return consumerData && consumerData.typeSaleAllowed && consumerData.typeSaleAllowed.allowPersonalCredit
            }

            if (isConsumerDebit) {
                return consumerData && consumerData.typeSaleAllowed && consumerData.typeSaleAllowed.allowConsumerDebit
            }

            if (!isConsumerDebit && !isPersonalCredit) {
                return true
            }
        },
        showNotAllowedMethodAlert: function () {
            Util.showInfoModal(this.getString('pagamento_nao_disponivel_para_este_usuario'))
            this.closeModal()
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        formatMoney: function (price) {
            return Util.formatMoney(price)
        },
        decreaseQtty: function (key) {
            CartController.decreaseQtty(key, this)
            this.$forceUpdate()
        },
        increaseQtty: function (key) {
            CartController.increaseQtty(key)
            this.$forceUpdate()
        },
        deleteProduct: function (key) {
            CartController.deleteProduct(key, this)
            this.$forceUpdate()
        },
        updateHasQuantityExceeded: function () {
            this.hasQuantityExceeded = CartController.checkAllUnavailableProducts()
        },
        getProductPrice: function (prod) {
            return CartController.calculateItemPrice(prod)
        },
        getLimits: function (productCode) {
            if (this.productsUnavailable && this.productsUnavailable[productCode]) {
                return this.productsUnavailable[productCode].quantity > this.productsUnavailable[productCode].quantityAvailable
            }
            return false
        },
        isModotap: function () {
            return Util.isTapMode() || Util.isBalancaMode()
        },
        editProduct: function (product, key) {
            this.$router.push({
                name: this.isGomLayout() ? 'Home' : 'ProductItem',
                params: { product, key, routeBack: 'Checkout' }
            })
        },
        isGomLayout: function () {
            return Util.getLocalConfigs('utiliza_layout_gom')
        },
        getProductsComboCombo: function (choosen) {
            let combos = []
            if (choosen) {
                Object.keys(choosen).forEach((e) => {
                    choosen[e].forEach((c) => {
                        if (c.unavailable) {
                            combos.push(c)
                        }
                    })
                })
            }
            return combos
        },
        buildText: function (productCode) {
            if (this.productsUnavailable && this.productsUnavailable[productCode]) {
                return `${this.productsUnavailable[productCode].quantity} ${this.getString('de')} ${this.productsUnavailable[productCode].quantityAvailable}`
            }
            return ''
        },
        getUnavaiableProducts: function () {
            return this.cart.filter(c => c.hasProductUnavailable === true || c.unavailable)
        },
        getUnavaiableCombo: function (combo) {
            return combo.filter(c => c.hasProductUnavailable || c.unavailable)
        },
        getUnavaiableObs: function (obs) {
            return obs.filter(o => o.unavailable === true)
        },
        backToMenu: function () {
            if (this.isModotap()) {
                CartController.clearCartAndNavigateHome(this.$router)
            } else {
                Util.showConfirmationDialog(this.$modal, () => {
                    this.$router.push({ name: 'Home', params: { openCart: true } })
                }, this.getString('alteracoes_desfeitas'))
            }
        },
        overrideCart: function () {
            CartController.overrideCart(this.cart)
            this.updateHasQuantityExceeded()
            if (!this.hasQuantityExceeded) {
                this.updateTaaPrices().then(() => {
                    this.hasProductUnavailable = false
                })
            }
        },
        changeMethod: function (method) {
            if (method !== 'faceRecognition') {
                this.faceDetection = false
            }
        },
        configExibeSaldoConsumidorSemControle: function () {
            if (this.controlaSaldo) {
                return true
            }
            return this.exibeSaldoConsumidorSemControle
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.balance-container {
    width: 80%;
    display: flex;
    flex-direction: column;
    margin: 0 10%;
}

.modal-container-cont:not(.form) {
    .full;
    pointer-events: none;
    display: block;
    bottom: 0;
    z-index: 900;
    padding: 30px;
}

.recharge-unavailable {
    display: block;
    margin: 0 auto;
    color: rgb(255, 16, 16);
    font-size: 28px;
    text-align: center;
}

.modal-container-cont:not(.form) > .modal-container {
    position: absolute;
    pointer-events: auto;
    left: 0;
    right: 0;
    top: 50%;
    margin: auto 75px;
    background: @white;
    border-radius: 25px;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    transform: translate(0%, -50%);
    display: flex;
    flex-direction: column;
    align-items: stretch;
    min-height: 0;
    max-height: 92vh;
    overflow: hidden auto;
    box-sizing: border-box;
    &.faceDetection {
        position: fixed;
        inset: 0;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: 0;
        height: 100vh;
        width: 100vw;
        border-radius: 0;
        transform: none;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        max-height: none;

        > .modal-form-container {
            .title-box {
                position: fixed;
                top: 0;
                width: 100%;
                left: 0;
                border-radius: 0;
            }
        }

        .user-verification-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            align-self: center;
            overflow: hidden auto;
            margin: 120px 0;
            justify-content: space-evenly;
            height: 90vh;
            width: 100%;

            .user-verification-content {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                img {
                    display: block;
                    margin: auto;
                    width: 150px;
                    height: 150px;
                    border: solid 1px;
                    border-radius: 100%;
                    object-fit: contain;
                    padding: 10px;
                    margin-bottom: 30px;
                }

                h1 {
                    font-size: 40px;
                    margin: 50px 0;
                }

                button {
                    width: 100%;
                }
            }

            .change-method-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 60px;
                margin: 60px 0;
                width: 100%;

                h2 {
                    font-size: 30px;
                    margin-bottom: 30px;
                }

                .change-method-buttons {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    margin: 15px auto;
                    width: 100%;

                    button {
                        width: 40%;
                        max-width: unset;
                        margin: 0 10px;
                    }
                }
            }
        }
    }

    > .modal-form-container {
        position: relative;
        overflow: hidden auto;
        flex: 0 0 auto;
        .title-box {
            background-color: @primary-color;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 25px 25px 0px 0px;

            h2 {
                color: @white;
                margin: auto;
                font-size: 40px;
            }
        }
    }

    .ai-face-detection-container {
        // margin: 15px auto;
        // width: 500px;
        max-height: 730px;
        max-width: 60%;

        .image-base64 {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .change-method-button {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin: 40px auto;
    }

    .hidden-input {
        position: fixed;
        margin: -10px 0;
        height: 1px;
        width: 1px;
        width: auto;
        font-size: 1px;
        border: none;
        box-shadow: none !important;
        background-color: rgba(0, 0, 0, 0);
        color: rgba(0, 0, 0, 0);
        z-index: -1;
        outline: none;
    }

    input:focus {
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
        background-color: rgba(0, 0, 0, 0);
    }

    .form {
        flex: 1 1 auto;
        min-height: 0;
        width: 100%;
        margin: 0;
        align-self: stretch;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        overflow: hidden;
        ::v-deep .modal-form-container {
            display: none;
        }

        ::v-deep .modal-container {
            flex: 1 1 auto;
            min-height: 0;
            margin: 0;
            max-height: none;
        }

        .config-item {
            display: grid;
            grid-template-columns: 40% 60%;
            position: relative;

            label {
                font-size: 30px;
                position: relative;
                display: inline-block;
                top: 50%;
                transform: translate(0, -50%);
                margin: 0;
            }

            input {
                vertical-align: middle;
                font-size: 2rem !important;
                padding: 5px 15px;
                border: 2px solid @primary-color;
                outline: none;

                &[type=text] {
                    color: black;
                }

                &[type=color] {
                    border: none;
                    height: 100px;
                    width: 100%;
                    box-sizing: inherit;
                    appearance: initial;
                    padding: 0;
                }
            }

            .disabled-input {
                pointer-events: none;
                background: rgba(0, 0, 0, 0.1);
                border: 2px solid lightgray;
                color: gray !important;
            }

            .disabled-label {
                pointer-events: none;
            }
        }

        .distance-bottom {
            margin-bottom: 45px;
        }

        .div-input-android {
            position: relative;
            display: flex;
            align-items: center;
            font-size: 2rem;
            height: 55px;
            background-color: white;
            color: black;
            border: 2px solid @black;
            padding: 0 20px;
        }

        .active-input {
            border: 3px solid @primary-color;
        }

        &.lockKeyboardCons {
            height: 200px;
        }
    }

    .barcode-info {
        margin: 10px 50px 50px 50px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;

        img {
            width: 300px;
            height: 150px;
        }

        p {
            text-align: center;
            font-size: 28px;
            margin: 10px;
        }
    }

    .face-detection-info {
        margin: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
            width: 300px;
            height: 150px;
        }

        p {
            text-align: center;
            font-size: 28px;
            margin: 10px;
        }
    }

    #android-keyboard {
        // margin: 0 30px 60px 30px;
        margin: 30px;
    }

    .new-login-button {
        display: block;
        margin: 0px auto 70px auto;
    }

    .balance-information {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        max-height: 750px;
        overflow: hidden auto;
        margin: 60px 0;

        .balance-row {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: baseline;
            padding: 0 20px;
        }

        .balance-inner-information {
            display: flex;
            flex-direction: column;
            width: 100%;
            margin-bottom: 60px;
        }

        .total-div {
            margin-bottom: 60px;
        }

        .upper-div {
            margin-bottom: 15px;
        }

        .margin-top {
            margin-top: 15px;
        }

        h2 {
            font-size: 40px;
            color: @primary-color;
            margin-bottom: 60px;
            text-align: center;
        }

        .balance-text {
            font-size: 35px;
        }

        .balance-value {
            font-size: 35px;
            color: @primary-color;
            white-space: nowrap;
        }
    }

    .recharge-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 30px;
    }

    .prod-item-footer {
        position: relative;
        display: flex;
        background: rgba(0, 0, 0, 0.1);
        height: 180px;
        border-radius: 0px 0px 25px 25px;

        &.faceDetection {
            background: white;
        }

        button {
            position: relative;
            display: block;
            margin: auto;
        }
    }

    .products-title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 35px;
        text-align: center;
        color: rgb(226, 0, 0);
        padding: 15px 0;
        margin-bottom: 10px;

        span {
            font-size: 25px;
        }

        .alert {
            padding-top: 10px;
            font-size: 30px;
        }
    }

    .products-container {
        overflow: auto;
        max-height: 800px;
        margin: 0 20px;

        .products {
            display: grid;
            grid-template-columns: 70% 30%;
            // align-items: center;
            margin-bottom: 10px;
            border-bottom: solid 1px rgba(0, 0, 0, 0.5);
            padding: 0 15px;

            &:last-of-type {
                border: none;
            }

            .name-container {
                color: @primary-color;
                display: flex;
                flex-direction: column;
                padding: 20px 5px;

                .product-obs {
                    padding-left: 30px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                }

                .name-product {
                    font-size: 30px;
                    font-weight: bold;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    justify-content: space-between;
                }

                .details-container {
                    display: grid;
                    grid-template-columns: 60% 40%;
                    color: black;
                    font-size: 25px;
                    text-align: left;
                    padding: 0 10px;
                    max-height: 100px;
                    overflow: auto;

                    p {
                        padding: 0;
                    }

                    .left-side {
                        display: grid;
                        grid-template-columns: auto;
                    }

                    .right-side {
                        display: grid;
                        grid-template-columns: auto;
                        text-align: start;
                    }
                }

                .combo-items {
                    padding-left: 30px;
                    display: flex;
                    flex-direction: column;

                    li {
                        padding: 5px 0;

                        .combo-item {
                            padding: 5px;
                            padding-left: 5px;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                        }

                        .combo-obs {
                            padding: 5px;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                        }

                        .limits {
                            // text-align: end;
                            color: rgb(226, 0, 0);
                        }
                    }

                    .c-combo-items {
                        padding-left: 30px;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                    }
                }

                &.tap-mode {
                    padding: 10px 5px;
                }

                .unavaiable {
                    color: rgb(226, 0, 0);
                }
            }

            .price-container {
                // background-color: @primary-light;
                display: flex;
                flex-direction: column-reverse;
                justify-content: space-between;
                align-items: center;
                // flex-wrap: nowrap;
                // height: 250px;
                min-height: 180px;
                padding: 20px;

                span {
                    font-size: 40px;
                }

                .circle_buttons {
                    display: flex;
                    // margin: auto;
                    width: -webkit-fill-available;
                    justify-content: space-between;
                    padding: 20px;

                    button {
                        // margin-right: 1.5rem;
                        width: 85px !important;
                    }
                }
            }

            &.tap-mode {
                grid-template-columns: auto;
            }
        }
    }
}

#keyboard {
    .keyboard;
    width: inherit;
    max-width: 930px;
    top: inherit;
    bottom: 0;
    position: unset;
}

.inner-overlay {
    z-index: 4;
    .full;
    content: '';
    background: black;
    opacity: .5;
    pointer-events: auto;
}

@media (max-width: 698px) {
    // Gertec SK210
    .modal-container-cont {
        .recharge-unavailable {
            font-size: 16px;
            line-height: 20px;
            padding: 0 10px;
        }
    }

    .modal-container-cont:not(.form) > .modal-container {
        margin: auto;

        .modal-form-container {
            .title-box {
                height: 50px;

                h2 {
                    font-size: 30px;
                }
            }
        }

        .change-method-button {
            margin: 5px;
        }

        .ai-face-detection-container {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 5px auto;
            height: 250px;
        }

        .form {
            margin: 0;
            min-height: 0;
            height: auto;

            .config-item {
                grid-template-columns: 30% 70%;

                label {
                    font-size: 20px;
                }
            }

            .distance-bottom {
                margin-bottom: 15px;
            }

            .div-input-android {
                font-size: 25px;
                height: 35px;
                border: 1px solid @black;
                padding: 0 10px;
            }

            .active-input {
                border: 2px solid @primary-color;
            }

            &.lockKeyboardCons {
                min-height: 90px;
            }
        }

        .barcode-info {
            margin: 5px 20px 20px 20px;

            img {
                width: 150px;
                height: 70px;
            }

            p {
                text-align: center;
                font-size: 16px;
                margin: 5px;
            }
        }

        .face-detection-info {
            margin: 5px;
            display: flex;

            p {
                text-align: center;
                font-size: 16px;
                margin: 5px;
            }
        }

        #android-keyboard {
            margin: 0;
            .small-screen-keyboard;
            bottom: 30px;
        }

        .new-login-button {
            margin: 0px auto 20px auto;
        }

        .balance-information {
            margin: 20px 0;
            max-height: 250px;

            .balance-inner-information {
                margin-bottom: 20px;
            }

            .total-div {
                margin-bottom: 20px;
            }

            .upper-div {
                margin-bottom: 5px;
            }

            h2 {
                font-size: 20px;
                margin-bottom: 20px;
            }

            .balance-text {
                font-size: 15px;
            }

            .balance-value {
                font-size: 15px;
            }
        }

        .recharge-button {
            margin: 5px 0;
        }

        .prod-item-footer {
            height: 60px;
        }

        .products-title {
            font-size: 18px;

            span {
                font-size: 16px;
            }
        }

        .products-container {
            max-height: 200px;
            margin: 0 10px;

            .products {
                padding: 0 10px;

                .name-container {
                    padding: 10px 5px;
                    font-size: 12px;

                    .product-obs {
                        padding-left: 5px;
                        font-size: 12px;
                    }

                    .name-product {
                        font-size: 13px;
                        padding-bottom: 5px;
                    }

                    .combo-item {
                        span {
                            font-size: 12px;
                        }
                    }

                    .combo-obs {
                        span {
                            font-size: 12px;
                        }
                    }

                    .combo-items {
                        padding-left: 15px;

                        li {
                            padding: 3px 0;
                        }

                        .c-combo-items {
                            padding-left: 10px;
                            font-size: 12px;
                        }
                    }

                    &.tap-mode {
                        padding: 10px 5px;
                    }
                }

                .price-container {
                    min-height: 100px;
                    padding: 15px;

                    span {
                        font-size: 18px;
                    }

                    .circle_buttons {
                        padding: 5px;

                        button {
                            width: 35px !important;
                        }
                    }
                }

                &.tap-mode {
                    grid-template-columns: auto;
                }
            }
        }

        .user-verification-container {
            margin: 50px 0;
            height: 90vh;

            .user-verification-content {
                img {
                    width: 80px;
                    height: 80px;
                    padding: 5px;
                    margin-bottom: 15px;
                }

                h1 {
                    font-size: 20px;
                    margin: 20px 0;
                }

                button {
                    width: 100%;
                }
            }

            .change-method-container {
                margin: 20px 0;
                width: 100%;

                h2 {
                    font-size: 16px;
                    margin-bottom: 15px;
                }

                .change-method-buttons {
                    margin: 10px auto;
                    width: 100%;

                    button {
                        width: 40%;
                        max-width: unset;
                        margin: 0 5px;
                    }
                }
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    .modal-container-cont {
        .recharge-unavailable {
            font-size: 22px;
        }
    }

    .modal-container-cont:not(.form) > .modal-container {
        margin: auto 25px;

        .modal-form-container {
            .title-box {
                height: 100px;

                h2 {
                    font-size: 35px;
                }
            }
        }

        .ai-face-detection-container {
            margin: 15px auto;
            // width: 500px;
            height: 550px;

            .image-base64 {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }

        .change-method-button {
            margin: 15px;
        }

        .form {
            margin: 0;
            min-height: 0;
            height: auto;

            .config-item {
                grid-template-columns: 35% 65%;
            }

            &.lockKeyboardCons {
                min-height: 150px;
            }
        }

        .barcode-info {
            margin: 5px 20px 20px 20px;

            img {
                width: 200px;
                height: 100px;
            }

            p {
                text-align: center;
                font-size: 25px;
                margin: 10px;
            }
        }

        .new-login-button {
            margin: 0 auto 30px auto;
        }

        .balance-information {
            margin: 80px 0px;
            max-height: 470px;

            .balance-inner-information {
                margin-bottom: 50px;
            }

            .total-div {
                margin-bottom: 40px;
            }

            .upper-div {
                margin-bottom: 10px;
            }

            h2 {
                font-size: 35px;
                margin-bottom: 40px;
            }

            .balance-text {
                font-size: 27px;
            }

            .balance-value {
                font-size: 27px;
            }
        }

        .prod-item-footer {
            height: 130px;
        }

        .products-title {
            font-size: 25px;

            span {
                font-size: 20px;
            }
        }

        .products-container {
            max-height: 600px;
            margin: 0 15px;

            .products {
                padding: 0 15px;

                .name-container {
                    padding: 20px 5px;

                    .product-obs {
                        padding-left: 10px;
                    }

                    .name-product {
                        font-size: 20px;
                    }

                    .combo-items {
                        padding-left: 20px;

                        li {
                            padding: 5px 0;
                        }

                        .c-combo-items {
                            padding-left: 15px;
                        }
                    }

                    &.tap-mode {
                        padding: 10px 5px;
                    }
                }

                .price-container {
                    min-height: 150px;
                    padding: 20px;

                    span {
                        font-size: 25px;
                    }

                    .circle_buttons {
                        padding: 5px;

                        button {
                            width: 50px !important;
                        }
                    }
                }

                &.tap-mode {
                    grid-template-columns: auto;
                }
            }
        }

        .user-verification-container {
            margin: 80px 0;
            height: 90vh;

            .user-verification-content {
                img {
                    width: 100px;
                    height: 100px;
                    padding: 8px;
                    margin-bottom: 20px;
                }

                h1 {
                    font-size: 28px;
                    margin: 35px 0;
                }

                button {
                    width: 100%;
                }
            }

            .change-method-container {
                margin: 40px 0;
                width: 100%;

                h2 {
                    font-size: 22px;
                    margin-bottom: 20px;
                }

                .change-method-buttons {
                    margin: 12px auto;
                    width: 100%;

                    button {
                        width: 40%;
                        max-width: unset;
                        margin: 0 8px;
                    }
                }
            }
        }

        #android-keyboard {
            // margin: 0 30px 60px 30px;
            margin: 0;
        }
    }

    #keyboard {
        .keyboard;
        width: inherit;
        position: unset;
        max-width: 760px;
        font-size: 20px;
    }
}

@media (orientation: landscape) {
    .modal-container-cont {
        .recharge-unavailable {
            font-size: 16px;
            line-height: 20px;
            padding: 0 10px;
        }
    }

    .modal-container-cont:not(.form) > .modal-container {
        margin: auto 30px;

        .modal-form-container {
            .title-box {
                height: 50px;

                // border-radius: 0;
                h2 {
                    font-size: 30px;
                }
            }
        }

        .form {
            margin: 0;
            min-height: 0;
            height: auto;
            padding: 20px 20px;

            .config-item {
                grid-template-columns: 30% 70%;

                label {
                    font-size: 20px;
                }
            }

            .distance-bottom {
                margin-bottom: 15px;
            }

            .div-input-android {
                font-size: 25px;
                height: 35px;
                border: 1px solid @black;
                padding: 0 10px;
            }

            .active-input {
                border: 2px solid @primary-color;
            }

            &.lockKeyboardCons {
                min-height: 90px;
            }
        }

        .barcode-info {
            margin: 5px 20px 20px 20px;

            img {
                width: 150px;
                height: 70px;
            }

            p {
                text-align: center;
                font-size: 16px;
                margin: 5px;
            }
        }

        .ai-face-detection-container {
            margin: 15px auto;
            // width: 500px;
            height: 350px;

            .image-base64 {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }

        #android-keyboard {
            margin: 0;
            .small-screen-keyboard;
            bottom: 30px;
        }

        .new-login-button {
            margin: 0px auto 20px auto;
        }

        .balance-information {
            margin: 40px 0px;
            max-height: 400px;

            .balance-inner-information {
                margin-bottom: 20px;
            }

            .total-div {
                margin-bottom: 20px;
            }

            .upper-div {
                margin-bottom: 5px;
            }

            h2 {
                font-size: 27px;
                // margin-bottom: 20px;
            }

            .balance-text {
                font-size: 25px;
            }

            .balance-value {
                font-size: 25px;
            }
        }

        .recharge-button {
            margin: 5px 0;
        }

        .prod-item-footer {
            height: 60px;
        }

        .products-title {
            font-size: 18px;

            span {
                font-size: 16px;
            }
        }

        .products-container {
            max-height: 200px;
            margin: 0 10px;

            .products {
                padding: 0 10px;

                .name-container {
                    padding: 10px 5px;
                    font-size: 12px;

                    .product-obs {
                        padding-left: 5px;
                        font-size: 12px;
                    }

                    .name-product {
                        font-size: 13px;
                        padding-bottom: 5px;
                    }

                    .combo-item {
                        span {
                            font-size: 12px;
                        }
                    }

                    .combo-obs {
                        span {
                            font-size: 12px;
                        }
                    }

                    .combo-items {
                        padding-left: 15px;

                        li {
                            padding: 3px 0;
                        }

                        .c-combo-items {
                            padding-left: 10px;
                            font-size: 12px;
                        }
                    }

                    &.tap-mode {
                        padding: 10px 5px;
                    }
                }

                .price-container {
                    min-height: 100px;
                    padding: 15px;

                    span {
                        font-size: 18px;
                    }

                    .circle_buttons {
                        padding: 5px;

                        button {
                            width: 35px !important;
                        }
                    }
                }

                &.tap-mode {
                    grid-template-columns: auto;
                }
            }
        }

        .user-verification-container {
            margin: 50px 0;
            height: 90vh;

            .user-verification-content {
                img {
                    width: 80px;
                    height: 80px;
                    padding: 5px;
                    margin-bottom: 15px;
                }

                h1 {
                    font-size: 20px;
                    margin: 20px 0;
                }

                button {
                    width: 100%;
                }
            }

            .change-method-container {
                margin: 20px 0;
                width: 100%;

                h2 {
                    font-size: 16px;
                    margin-bottom: 15px;
                }

                .change-method-buttons {
                    margin: 10px auto;
                    width: 100%;

                    button {
                        width: 40%;
                        max-width: unset;
                        margin: 0 5px;
                    }
                }
            }
        }

        .prod-item-footer {
            height: 100px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCreditModal.vue